/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from 'react';
import { Close, Error, IconColors } from '../../Icons';
import styles from './global-messages.module.css';

interface ErrorMessageProps {
    primaryMessage: string;
    secondaryMessage?: string;
    dismiss: (event: React.MouseEvent<HTMLDivElement>) => void;
}

function ErrorMessage({
    dismiss,
    primaryMessage,
    secondaryMessage,
}: ErrorMessageProps): React.ReactElement<ErrorMessageProps> {
    return (
        <div className={`${styles.MessagePanel} ${styles.ErrorMessage}`}>
            <Error color={IconColors.Warning} aspect="1.75rem" />
            <div className={styles.MessagePanelInfo}>
                <p>{primaryMessage}</p>
                {!!secondaryMessage && <p>{secondaryMessage}</p>}
            </div>
            <div className={styles.MessagePanelClose} onClick={dismiss}>
                <Close aspect="1.25rem" color={IconColors.Warning} />
            </div>
        </div>
    );
}

export default ErrorMessage;
